import { render, staticRenderFns } from "./SchDetail.vue?vue&type=template&id=7582dd1e&"
import script from "./SchDetail.vue?vue&type=script&lang=js&"
export * from "./SchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports